/** Remboursement partiel ou total d’un encaissement. */
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Button } from "../../components/Button";
import "../../components/confirmModal.css";
import { centsToInput, inputToCents, typedDecimal } from "../catalog/types";

type PaymentRefundModalProps = {
  open: boolean;
  remainingCents: number;
  decimalComma: boolean;
  busy?: boolean;
  onCancel: () => void;
  onConfirm: (amountCents: number) => void;
};

export function PaymentRefundModal({ open, remainingCents, decimalComma, busy, onCancel, onConfirm }: PaymentRefundModalProps) {
  const [amount, setAmount] = useState("");

  useEffect(() => {
    if (!open) return;
    setAmount(centsToInput(remainingCents, decimalComma));
  }, [open, remainingCents, decimalComma]);

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape" && !busy) onCancel();
    };
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [open, busy, onCancel]);

  if (!open) return null;
  const cents = inputToCents(amount, decimalComma) ?? 0;

  const box = (
    <div className="fx-modal" role="dialog" aria-modal="true" aria-labelledby="fx-refund-title">
      <button type="button" className="fx-modal__backdrop" aria-label="Fermer" disabled={busy} onClick={onCancel} />
      <div className="fx-modal__card">
        <h2 id="fx-refund-title" className="fx-modal__title">
          Rembourser le paiement
        </h2>
        <p className="fx-modal__text">Le montant proposé est le reste encore encaissé. Il revient au solde de la facture.</p>
        <div className="fx-pay-fields">
          <label className="fx-pay-fields__lab">
            Montant
            <input className="fx-q-ctrl is-end" value={amount} inputMode="decimal" onChange={(e) => setAmount(typedDecimal(e.target.value, decimalComma))} />
          </label>
        </div>
        <div className="fx-modal__actions">
          <Button variant="ghost" onClick={onCancel} disabled={busy}>
            Annuler
          </Button>
          <Button disabled={busy || cents <= 0} onClick={() => onConfirm(cents)}>
            {busy ? "Enregistrement…" : "Rembourser"}
          </Button>
        </div>
      </div>
    </div>
  );

  return createPortal(box, document.body);
}
